/**
 * Lesson-specific curriculum copied from WritingLessonTwo–TwelveCourse.swift.
 */

export const WRITING_L2 = {
  letters: ["c", "o", "a", "d", "g", "q", "l", "i", "t"],
  roundLetters: ["c", "o", "a", "d", "g", "q"],
  lineLetters: ["l", "i", "t"],
  sounds: {
    c: "k, like cat",
    o: "ah, like octopus",
    a: "short a, like apple",
    d: "d, like dog",
    g: "g, like garden",
    q: "kw, like queen. Q often teams with U",
    l: "lll, like leaf",
    i: "short i, like insect",
    t: "t, like turtle",
  },
  mysteryWords: {
    c: "cat",
    o: "octopus",
    a: "apple",
    d: "dog",
    g: "garden",
    q: "queen",
    l: "leaf",
    i: "insect",
    t: "turtle",
  },
  sentences: [
    { word: "cat", sentenceStart: "The", sentenceEnd: "sat.", assetName: "c_word_cat", stretchedNarration: "K, short a, t. Cat." },
    { word: "dog", sentenceStart: "I had a", sentenceEnd: ".", assetName: "d_word_dog", stretchedNarration: "D, ah, g. Dog." },
  ],
};

export const WRITING_L3 = {
  letters: ["r", "n", "m", "h", "b", "p", "u", "j", "y"],
  bumpLetters: ["r", "n", "m", "h", "b"],
  tailLetters: ["p", "u", "j", "y"],
  sounds: {
    r: "rrr, like rainbow",
    n: "nnn, like nest",
    m: "mmm, like moon",
    h: "h, like hat",
    b: "b, like ball",
    p: "p, like puppy",
    u: "short u, like up",
    j: "j, like jam",
    y: "y, like yarn",
  },
  sentences: [
    { word: "hat", sentenceStart: "I had a", sentenceEnd: ".", assetName: "h_word_hat", stretchedNarration: "H, short a, t. Hat." },
    { word: "jam", sentenceStart: "I had some", sentenceEnd: ".", assetName: "j_word_jam", stretchedNarration: "J, short a, mmm. Jam." },
  ],
};

export const WRITING_L4 = {
  letters: ["v", "w", "x", "z", "k", "e", "f", "s"],
  slantLetters: ["v", "w", "x", "z", "k"],
  oddLetters: ["e", "f", "s"],
  sounds: {
    v: "vvv, like van",
    w: "w, like wagon",
    x: "ks, like fox",
    z: "zzz, like zebra",
    k: "k, like kite",
    e: "short e, like egg",
    f: "fff, like fox",
    s: "sss, like sun",
  },
  sentences: [
    { word: "fox", sentenceStart: "The", sentenceEnd: "is wet.", assetName: "f_word_fox", stretchedNarration: "Fff, short o, ks. Fox." },
    { word: "web", sentenceStart: "The", sentenceEnd: "is wet.", assetName: "w_word_web", stretchedNarration: "W, short e, b. Web." },
  ],
};

export const WRITING_KNOWN_LETTERS = {
  2: WRITING_L2.letters,
  3: [...WRITING_L2.letters, ...WRITING_L3.letters],
  4: [...WRITING_L2.letters, ...WRITING_L3.letters, ...WRITING_L4.letters],
};

export const WRITING_L5 = {
  rightAngleCapitals: ["L", "T", "I", "H", "E", "F"],
  slantedCapitals: ["A", "K", "M", "N", "V", "W", "X", "Y", "Z"],
  memoryRounds: ["H", "A", "T", "M", "K", "E", "V", "Z"],
  casePairs: [
    { capital: "L", lowercase: "l" },
    { capital: "T", lowercase: "t" },
    { capital: "I", lowercase: "i" },
    { capital: "H", lowercase: "h" },
    { capital: "E", lowercase: "e" },
    { capital: "F", lowercase: "f" },
    { capital: "A", lowercase: "a" },
    { capital: "K", lowercase: "k" },
  ],
  lowercaseDisplayOrder: ["h", "a", "f", "i", "k", "l", "e", "t"],
  sounds: {
    A: "short a, like apple", B: "b, like ball", C: "k, like cat", D: "d, like dog",
    E: "short e, like egg", F: "fff, like fish", G: "g, like game", H: "hhh, like hat",
    I: "short i, like igloo", J: "j, like jam", K: "k, like kite", L: "lll, like lamp",
    M: "mmm, like moon", N: "nnn, like nest", O: "short o, like octopus", P: "p, like pig",
    Q: "kw, like queen", R: "rrr, like rabbit", S: "sss, like sun", T: "t, like top",
    U: "short u, like umbrella", V: "vvv, like van", W: "w, like wagon", X: "ks, like fox",
    Y: "y, like yo-yo", Z: "zzz, like zebra",
  },
};

export const WRITING_L6 = {
  curveCapitalsOne: ["C", "O", "Q", "G", "S", "U", "J"],
  curveCapitalsTwo: ["B", "D", "P", "R"],
  memoryRounds: ["A", "M", "S", "T", "B", "R", "G", "Y"],
  pairRounds: ["a", "b", "c", "d", "m", "p", "r", "y"],
  nameSuggestions: ["Mia", "Sam", "Pip", "Coco"],
  choiceRounds: [
    { fragmentBefore: "", missingLetter: "t", fragmentAfter: "he sun is up.", kind: "sentenceStart" },
    { fragmentBefore: "", missingLetter: "m", fragmentAfter: "y dog can run.", kind: "sentenceStart" },
    { fragmentBefore: "", missingLetter: "w", fragmentAfter: "e can hop.", kind: "sentenceStart" },
    { fragmentBefore: "This is ", missingLetter: "m", fragmentAfter: "ia.", kind: "name" },
    { fragmentBefore: "I can see ", missingLetter: "s", fragmentAfter: "am.", kind: "name" },
    { fragmentBefore: "", missingLetter: "p", fragmentAfter: "ip is here.", kind: "name" },
  ],
  repairRounds: [
    { incorrectSentence: "the cat sat.", correctedSentence: "The cat sat.", capital: "T" },
    { incorrectSentence: "i had a hat.", correctedSentence: "I had a hat.", capital: "I" },
    { incorrectSentence: "my dog can run.", correctedSentence: "My dog can run.", capital: "M" },
  ],
};

export const WRITING_CAST = [
  { name: "Zippy", assetName: "zippy-icon", scrambledLetters: ["p", "Z", "y", "i", "p"], firstLetterChoices: ["B", "Z", "P"] },
  { name: "Pip", assetName: "pip", scrambledLetters: ["p", "P", "i"], firstLetterChoices: ["Z", "B", "P"] },
  { name: "Benny", assetName: "benny", scrambledLetters: ["n", "B", "y", "e", "n"], firstLetterChoices: ["P", "B", "Z"] },
];

export const WRITING_L7 = {
  members: WRITING_CAST,
  sentences: [
    { before: "I like ", after: ".", memberName: "Zippy" },
    { before: "", after: " is my friend.", memberName: "Pip" },
    { before: "I like ", after: ".", memberName: "Benny" },
  ],
};

export const WRITING_L8 = {
  numberNames: [
    { numeral: 0, word: "zero" }, { numeral: 1, word: "one" }, { numeral: 2, word: "two" },
    { numeral: 3, word: "three" }, { numeral: 4, word: "four" }, { numeral: 5, word: "five" },
    { numeral: 6, word: "six" }, { numeral: 7, word: "seven" }, { numeral: 8, word: "eight" },
    { numeral: 9, word: "nine" },
  ],
  countRounds: [
    { count: 1, singularName: "apple", pluralName: "apples", assetName: "a_word_apple" },
    { count: 2, singularName: "ball", pluralName: "balls", assetName: "a_word_ball" },
    { count: 3, singularName: "cat", pluralName: "cats", assetName: "c_word_cat" },
    { count: 4, singularName: "duck", pluralName: "ducks", assetName: "d_word_duck" },
    { count: 6, singularName: "fish", pluralName: "fish", assetName: "f_word_fish" },
    { count: 9, singularName: "flower", pluralName: "flowers", assetName: "f_word_flower" },
  ],
};

export const WRITING_L9 = {
  soundLetters: ["m", "s", "f", "n", "l", "v", "z", "t", "p", "k"],
  soundCues: {
    a: "aah", b: "b", c: "k", k: "k", d: "d", e: "eh", f: "fff", g: "g", h: "h",
    i: "ih", j: "j", l: "lll", m: "mmm", n: "nnn", o: "ah", p: "p", r: "rrr",
    s: "sss", t: "t", u: "uh", v: "vvv", w: "w", x: "ks", y: "y", z: "zzz",
  },
  soundToLetterRounds: [
    { target: "m", choices: ["m", "s", "f", "n"] },
    { target: "s", choices: ["f", "s", "m", "t"] },
    { target: "f", choices: ["v", "n", "f", "p"] },
    { target: "n", choices: ["l", "m", "z", "n"] },
    { target: "l", choices: ["l", "v", "t", "s"] },
    { target: "v", choices: ["f", "v", "z", "m"] },
    { target: "z", choices: ["s", "n", "z", "p"] },
    { target: "t", choices: ["k", "t", "p", "m"] },
    { target: "p", choices: ["p", "t", "f", "l"] },
    { target: "k", choices: ["n", "s", "k", "v"] },
  ],
  whichSoundRounds: [
    { letter: "m", sounds: ["s", "m", "f"] },
    { letter: "s", sounds: ["n", "f", "s"] },
    { letter: "f", sounds: ["f", "v", "l"] },
    { letter: "n", sounds: ["m", "n", "z"] },
    { letter: "l", sounds: ["t", "v", "l"] },
    { letter: "v", sounds: ["v", "f", "s"] },
    { letter: "z", sounds: ["s", "z", "n"] },
    { letter: "t", sounds: ["p", "k", "t"] },
    { letter: "p", sounds: ["p", "t", "m"] },
    { letter: "k", sounds: ["f", "k", "n"] },
  ],
  words: {
    cat: { word: "cat", assetName: "c_word_cat", sounds: ["c", "a", "t"] },
    dog: { word: "dog", assetName: "d_word_dog", sounds: ["d", "o", "g"] },
    pig: { word: "pig", assetName: "p_word_pig", sounds: ["p", "i", "g"] },
    sun: { word: "sun", assetName: "call_sun", sounds: ["s", "u", "n"] },
    map: { word: "map", assetName: "m_word_map", sounds: ["m", "a", "p"] },
    hat: { word: "hat", assetName: "h_word_hat", sounds: ["h", "a", "t"] },
    fox: { word: "fox", assetName: "f_word_fox", sounds: ["f", "o", "x"] },
    bus: { word: "bus", assetName: "a_word_bus", sounds: ["b", "u", "s"] },
  },
  firstLastRounds: [
    { word: { word: "moon", assetName: "a_word_moon", sounds: ["m", "oo", "n"] }, position: "first", answer: "m" },
    { word: { word: "sun", assetName: "call_sun", sounds: ["s", "u", "n"] }, position: "first", answer: "s" },
    { word: { word: "fish", assetName: "a_word_fish", sounds: ["f", "i", "sh"] }, position: "first", answer: "f" },
    { word: { word: "nest", assetName: "n_word_nest", sounds: ["n", "e", "s", "t"] }, position: "first", answer: "n" },
    { word: { word: "van", assetName: "post_van", sounds: ["v", "a", "n"] }, position: "first", answer: "v" },
    { word: { word: "zebra", assetName: "z_word_zebra", sounds: ["z", "ee", "b", "r", "a"] }, position: "first", answer: "z" },
    { word: { word: "cat", assetName: "c_word_cat", sounds: ["c", "a", "t"] }, position: "last", answer: "t" },
    { word: { word: "dog", assetName: "d_word_dog", sounds: ["d", "o", "g"] }, position: "last", answer: "g" },
    { word: { word: "hat", assetName: "h_word_hat", sounds: ["h", "a", "t"] }, position: "last", answer: "t" },
    { word: { word: "fox", assetName: "f_word_fox", sounds: ["f", "o", "x"] }, position: "last", answer: "x" },
    { word: { word: "bus", assetName: "a_word_bus", sounds: ["b", "u", "s"] }, position: "last", answer: "s" },
    { word: { word: "map", assetName: "m_word_map", sounds: ["m", "a", "p"] }, position: "last", answer: "p" },
  ],
  changeRounds: [
    { from: "cat", to: "hat", changedIndex: 0 },
    { from: "hat", to: "hot", changedIndex: 1 },
    { from: "hot", to: "hop", changedIndex: 2 },
    { from: "hop", to: "mop", changedIndex: 0 },
    { from: "mop", to: "map", changedIndex: 1 },
    { from: "map", to: "mat", changedIndex: 2 },
  ],
  wordWall: [
    { word: "cat", pattern: "-at", assetName: "c_word_cat" },
    { word: "fan", pattern: "-an", assetName: "f_word_fan" },
    { word: "ring", pattern: "-ing", assetName: null },
    { word: "kite", pattern: "magic e", assetName: "k_word_kite" },
  ],
  sentenceNouns: [
    { word: "ball", assetName: "a_word_ball" },
    { word: "car", assetName: "c_word_car" },
    { word: "kite", assetName: "k_word_kite" },
  ],
  sentenceColors: [
    { word: "red", assetName: "ch_balloon_red" },
    { word: "blue", assetName: "ch_book_blue" },
    { word: "green", assetName: "ch_light_green" },
  ],
};

WRITING_L9.ladderWords = ["cat", "dog", "pig", "sun"].map((k) => WRITING_L9.words[k]);
WRITING_L9.stretchChoices = ["cat", "dog", "pig", "sun", "map", "hat", "fox", "bus"].map((k) => WRITING_L9.words[k]);
WRITING_L9.builderWords = WRITING_L9.ladderWords;

export const WRITING_L10 = {
  pictureFrames: [
    {
      stem: "I can ___.",
      choices: [
        { word: "jump", assetName: "zippy jumping" },
        { word: "paint", assetName: "paint_panda" },
        { word: "read", assetName: "ch_book" },
      ],
      selectedIndex: 0,
    },
    {
      stem: "I like ___.",
      choices: [
        { word: "dogs", assetName: "d_word_dog" },
        { word: "balls", assetName: "a_word_ball" },
        { word: "books", assetName: "ch_bookshelf" },
      ],
      selectedIndex: 0,
    },
    {
      stem: "My book is ___.",
      choices: [
        { word: "red", assetName: "ch_book_red" },
        { word: "blue", assetName: "ch_book_blue" },
        { word: "green", assetName: "ch_book_green" },
      ],
      selectedIndex: 1,
    },
  ],
  todaysQuestion: "What did you enjoy today?",
  frameFadeModels: ["I like books.", "I like books.", "I like books."],
  oneMoreStart: "I played with my ball.",
  threeWaysKernel: "The cat was late",
  joinRounds: [
    { first: "I have a dog.", second: "My dog is brown.", joined: "I have a dog, and my dog is brown.", joiner: "and" },
    { first: "It began to rain.", second: "I used my coat.", joined: "It began to rain, so I used my coat.", joiner: "so" },
    { first: "I felt tired.", second: "I finished my book.", joined: "I felt tired, but I finished my book.", joiner: "but" },
  ],
  relativeRounds: [
    { first: "I have a dog.", second: "The dog likes walks.", joined: "I have a dog who likes walks.", joiner: "who" },
    { first: "I found a book.", second: "The book has a blue cover.", joined: "I found a book that has a blue cover.", joiner: "that" },
  ],
  runOn: "I made a kite it flew in the park",
  untangled: ["I made a kite.", "It flew in the park."],
  sprintPictures: [
    { word: "dog", assetName: "d_word_dog" },
    { word: "ball", assetName: "a_word_ball" },
    { word: "book", assetName: "ch_book" },
    { word: "cat", assetName: "c_word_cat" },
  ],
  completion: {
    pickFrames: 3,
    fadeStages: 3,
    todayGoalChecks: 3,
    capitalStopSentences: 3,
    oneMoreSentences: 1,
    threeWayEndings: 2,
    joinedPairs: 3,
    relativePairs: 2,
    untangledSentences: 2,
    pictureSentences: 1,
    sprintSeconds: 60,
  },
};

WRITING_L10.capitalStopSentences = WRITING_L10.pictureFrames.map((frame) =>
  frame.stem.replace("___", frame.choices[frame.selectedIndex].word),
);

export const WRITING_STORY_PARTS = [
  { id: "who", title: "Who" },
  { id: "wherePart", title: "Where" },
  { id: "whenPart", title: "When" },
  { id: "order", title: "Order" },
  { id: "whatHappens", title: "What" },
  { id: "problem", title: "Problem" },
  { id: "ending", title: "Ending & Feeling" },
];

export const WRITING_L11 = {
  partWords: [
    { word: "sleepy", kind: "who", assetName: "call_moon" },
    { word: "park", kind: "where", assetName: "ch_bg_park" },
    { word: "morning", kind: "when", assetName: "call_sun" },
    { word: "found", kind: "what", assetName: "a_word_ball" },
  ],
  findRounds: [
    {
      story: ["One sunny morning, Max visited the park.", "Max found a red ball beside a tree."],
      part: "wherePart",
      answerIndex: 0,
    },
    {
      story: ["Lina the cat felt curious.", "She followed a butterfly through the garden."],
      part: "whatHappens",
      answerIndex: 1,
    },
  ],
  whoShort: "Max is a big dog",
  whoGrown: "Max is a big dog who likes mud",
  whereSentence: "Max was at the muddy park",
  whenSentence: "One sunny morning, Max ran",
  orderedMoments: ["woke up", "found a ball", "shared it"],
  orderedMomentAssets: ["call_sun", "a_word_ball", "d_word_dog"],
  orderLabels: ["first", "then", "last"],
  whatShort: "Max found a ball",
  whatGrown: "Max found a ball and ran with it",
  problem: "Max wanted the ball, but a big dog took it",
  responseLines: ["Then Max asked to share", "So both dogs played"],
  endings: ["In the end, they shared the ball", "In the end, Max went home smiling"],
  feeling: "Max felt proud because he shared",
  sequential: {
    whoSentence: { short: "Max is a big dog", grown: "Max is a big dog who likes mud", growWord: "who", part: "who" },
    whereSentence: { short: "Max was at the muddy park", grown: null, growWord: null, part: "wherePart" },
    whenSentence: { short: "One sunny morning, Max ran", grown: null, growWord: null, part: "whenPart" },
    whatHappensSentence: { short: "Max found a ball", grown: "Max found a ball and ran with it", growWord: "and", part: "whatHappens" },
    wantsAndBut: { short: "Max wanted the ball, but a big dog took it", grown: null, growWord: null, part: "problem", model: "Pip says: I wanted the blue kite, but the wind carried it into a friendly tree." },
    thenAndSo: { short: "Then Max asked to share. So both dogs played", grown: null, growWord: null, part: "order" },
    feelingSentence: { short: "Max felt proud because he shared", grown: null, growWord: null, part: "ending" },
  },
  closedSafeVocabulary: new Set([
    "sleepy", "park", "morning", "found", "sunny", "max", "big", "dog", "mud", "muddy",
    "woke", "up", "ball", "shared", "ran", "wanted", "took", "asked", "share", "both", "dogs",
    "played", "home", "smiling", "felt", "proud", "because", "he", "it", "one", "first", "then",
    "last", "in", "the", "end", "went", "with", "and", "but", "so", "at", "was", "is", "a", "who", "likes",
    "to", "they",
  ]),
};

export const WRITING_L12_PARTS = [
  { id: "who", title: "Who" },
  { id: "when", title: "When" },
  { id: "where", title: "Where" },
  { id: "want", title: "What they want" },
  { id: "happens", title: "What happens" },
  { id: "ending", title: "How it ends" },
  { id: "feeling", title: "How everyone feels" },
];

export const WRITING_L12 = {
  powOrder: ["Pick my idea", "Organize my notes", "Write and say more"],
  detectiveStory: [
    { part: "who", text: "Mia loved making bright paper kites." },
    { part: "when", text: "On Saturday morning, she packed her kite." },
    { part: "where", text: "She walked to the sunny park." },
    { part: "want", text: "Mia wanted her kite to touch the clouds." },
    { part: "happens", text: "A gentle breeze lifted it over a low branch." },
    { part: "ending", text: "Mia and her dad guided the kite safely home." },
    { part: "feeling", text: "They felt proud and happy together." },
  ],
  sortStory: [
    { part: "who", text: "Luca was a small, curious rabbit." },
    { part: "when", text: "One warm afternoon, he began a walk." },
    { part: "where", text: "He explored the flower garden." },
    { part: "want", text: "Luca wanted to find a yellow flower." },
    { part: "happens", text: "He followed a butterfly around the pond." },
    { part: "ending", text: "At last, he found the flower beside his home." },
    { part: "feeling", text: "Luca felt calm and delighted." },
  ],
  thinkAloud: [
    { title: "Pick", text: "I will write about Pip planting a tiny seed." },
    { title: "Organize", text: "Who is Pip? Where is the garden? Pip wants the seed to grow." },
    { title: "Write", text: "Pip plants the seed, waters it, and waits patiently." },
    { title: "Stuck", text: "I am stuck on my ending. I can pause and look at my notes." },
    { title: "Fix", text: "I found it. A sunflower opens, and Pip feels proud." },
  ],
  organizerChoices: {
    who: ["Pip", "Mia and her dog", "a curious rabbit"],
    when: ["one sunny morning", "after lunch", "on Saturday"],
    where: ["the flower garden", "a quiet park", "beside a pond"],
    want: ["find a bright kite", "help a friend", "grow a sunflower"],
    happens: ["a breeze begins", "they follow a trail", "the seed starts to sprout"],
    ending: ["they get home safely", "the friends solve it together", "the flower opens"],
    feeling: ["proud and calm", "happy together", "surprised and glad"],
  },
  revisionQuestions: [
    "Are all the story parts there?",
    "Does every sentence start with a capital and end with a mark?",
    "Did I grow one sentence with and, but, because, or so?",
  ],
  growChoices: ["and", "but", "because", "so"],
  readerQuestion: "Which part surprised you?",
  minimumOrganizerParts: 5,
  minimumDraftSentences: 6,
  goalChoices: [5, 7],
};

export function writingSoundForLetter(letter) {
  const lower = String(letter || "").toLowerCase();
  return (
    WRITING_L4.sounds[lower] ||
    WRITING_L3.sounds[lower] ||
    WRITING_L2.sounds[lower] ||
    WRITING_L5.sounds[String(letter || "").toUpperCase()] ||
    "a letter sound"
  );
}

export function writingLetterNarration(letter) {
  if (letter === "n") return "Lowercase N. N is for nest.";
  return `Lowercase ${letter}. It can say ${writingSoundForLetter(letter)}.`;
}

export function writingCapitalCue(capital) {
  const upper = String(capital || "").toUpperCase();
  const sound = WRITING_L5.sounds[upper] || writingSoundForLetter(upper);
  return `Capital ${upper}. ${upper} says ${sound}.`;
}

export function sanitizedPracticeName(raw) {
  const folded = String(raw || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  const letters = folded.replace(/[^A-Za-z]/g, "").slice(0, 12);
  if (!letters) return "";
  return letters[0].toUpperCase() + letters.slice(1).toLowerCase();
}

export function profileWritingName(raw) {
  const safe = sanitizedPracticeName(raw);
  return safe || "Friend";
}

/** Exact iOS WritingWatchAndTapGameView choice order. */
export function watchAndTapChoices(letters, target, round) {
  const others = letters.filter((item) => item !== target);
  if (!others.length) return [target];
  const values = [
    others[(round * 2) % others.length],
    others[(round * 2 + 3) % others.length],
  ];
  values.splice((round * 2 + 1) % 3, 0, target);
  return values.slice(0, 3);
}

export function whichIsRightChoices(letters, target, round) {
  const others = letters.filter((l) => l !== target);
  const choices = [
    target,
    others[(round * 3 + 1) % others.length],
    others[(round * 5 + 4) % others.length],
  ];
  const targetIndex = (round * 2 + 1) % choices.length;
  [choices[0], choices[targetIndex]] = [choices[targetIndex], choices[0]];
  return choices;
}

export function lessonLetters(lessonNumber) {
  if (lessonNumber === 2) return WRITING_L2.letters;
  if (lessonNumber === 3) return WRITING_L3.letters;
  if (lessonNumber === 4) return WRITING_L4.letters;
  return [];
}

export function lessonSentences(lessonNumber) {
  if (lessonNumber === 2) return WRITING_L2.sentences;
  if (lessonNumber === 3) return WRITING_L3.sentences;
  if (lessonNumber === 4) return WRITING_L4.sentences;
  return [];
}

export function lessonMysteryPrompt(lessonNumber, letter) {
  if (lessonNumber === 2) {
    const word = WRITING_L2.mysteryWords[letter] || "this word";
    return `Which lowercase letter does ${word} start with?`;
  }
  return `Listen again. ${writingLetterNarration(letter)}`;
}
